export default __webpack_public_path__ + "static/media/alert-icon-5.25193171.svg";